//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum MyProductsTableOrderColumn {
  name = 0,
  createdAt = 1,
  ConnectOzon = 2,
  ConnectWb = 3,
  ConnectYandexMarket = 4,
  type = 5,
  code = 6,
  article = 7,
  price = 8,
  basePrice = 9,
  ozonSyncEnabled = 10,
  ozonArticle = 11,
  ozonIsVisible = 12,
  wbSyncEnabled = 13,
  wbChrtId = 14,
  yandexMarketSyncEnabled = 15,
  yandexMarketShopSku = 16
}
